import React from 'react';

import LoadingEllipsis from '../../components/LoadingEllipsis';

import { container } from './styles.module.css';

const Loading = () => {
  return (
    <div className={container}>
      <LoadingEllipsis />
    </div>
  );
};

export default Loading;
